export default {"src":"/_next/static/media/logos.dfeff55f.svg","height":280,"width":384,"blurWidth":0,"blurHeight":0};